import { NO_DATA_SIGN, THRESHOLD_FOR_KEYWORD_RESEARCH_VALUE } from "app/filters/const";
import { minAbbrNumberFilter } from "app/filters/ngFilters";

export const valueFormatter = (value: number) => {
    if (value === 0) {
        return NO_DATA_SIGN;
    }
    return (minAbbrNumberFilter()(value, THRESHOLD_FOR_KEYWORD_RESEARCH_VALUE) as number | string).toString();
};
